var R="ROLE_USER",E="ROLE_AGENT",O="ROLE_CASHER",_="ROLE_AIRPORT_CASHER",A="ROLE_CORPORATE";export{E as AGENT,_ as AIRPORT_CASHIER,O as CASHIER,A as CORPORATE,R as USER};
